import React, { FC, ReactNode } from 'react';

import { StyledHeader, StyledHeaderContainer } from './AppHeader.styles';

export interface AppHeaderProps {
  children?: ReactNode;
}

/**
 * @since 0.14.0
 */
const AppHeader: FC<AppHeaderProps> = ({ children }) => (
  <StyledHeader data-testid="AppHeader">
    <StyledHeaderContainer>
      {children}
    </StyledHeaderContainer>
  </StyledHeader>
);

export default AppHeader;
